import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { registerAction } from "../../redux/actions/userAction";
import { useDispatch, useSelector } from "react-redux";
import { Toaster, toast } from "react-hot-toast";

const Signup = () => {
  const [emailaddress, setEmailAddress] = useState("");
  const [name, setName] = useState("");

  const [password, setPassword] = useState("");
  const [password1, setPassword1] = useState("");
  const { error, loading, message } = useSelector((state) => state.user);
  const [imagePreview, setImagePreview] = useState("https://t4.ftcdn.net/jpg/02/15/84/43/360_F_215844325_ttX9YiIIyeaR7Ne6EaLLjMAmy4GvPC69.jpg")
  const [image, setImage] = useState()
  const dispatch = useDispatch();


  

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch({
        type: "clearError",
      });
    }

    if (message) {
      toast.success(message);
      dispatch({
        type: "clearMessage",
      });
    }
  }, [dispatch, error, message]);

  const signupHandler = (e) => {
    e.preventDefault();
    // const data = {
    //   name: name,
    //   email: emailaddress,
    //   password: password,
    // };
    // console.log(data)
   if(password!==password1){

    toast.error("password should match");

   } 
   if(!image){

    toast.error("Profile Pic is Mandatory");

   }
   
   else {

    const myForm = new FormData();

    myForm.append('name', name);
    myForm.append('email', emailaddress);
    myForm.append('password', password);
    myForm.append('file', image);

    // console.log(myForm)

    dispatch(registerAction(myForm));



   }

  };

  const changeImageHandler = (e) => {
    console.log(e.target.files[0])

    const file = e.target.files[0];
    // console.log(file)
    const reader = new FileReader();
   
    reader.readAsDataURL(file)

    reader.onloadend = () => {
      setImagePreview(reader.result)
      setImage(file)
      // console.log(reader.result)
      // console.log(file)
    }
    
  }

  return (
    <>
      <Toaster />
      <div className="bg-brand_nero flex flex-col justify-center items-center h-[800px] py-24 my-auto text-white  w-full">
        <div className="bg-brand_jaguar h-[600px] px-12 lg:px-24 flex flex-col justify-center items-center lg:w-[600px]">
          <h1 className="lg:text-xl my-3">Create your account to get started.</h1>
          <div> 
            <img src={imagePreview} className="h-[60px] w-[60px] bg- rounded-full" alt="Profile Pic" />
          </div>
          <form
            onSubmit={(e) => {
              signupHandler(e);
            }}
            action=""
            className="flex-col flex px-4 my-6 lg:w-[400px]"
          >
            <input
              className="my-3 py-1 px-6 text-white bg-brand_jaguar border-b-2 outline-0 	focus:border-brand_yellow	"
              type="text"
              value={name}
              placeholder="Name"
              onChange={(e) => {
                setName(e.target.value);
              }}
            />

            <input
              className="my-3 py-1 px-6 text-white bg-brand_jaguar border-b-2 outline-0 	focus:border-brand_yellow	"
              type="text"
              value={emailaddress}
              placeholder="Email Address"
              onChange={(e) => {
                setEmailAddress(e.target.value);
              }}
            />

            <input
              className="my-3 py-1 px-6 text-white bg-brand_jaguar border-b-2 outline-0	focus:border-brand_yellow"
              type="password"
              value={password}
              placeholder="Password"
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
            <input
              className="my-3 py-1 px-6  text-white bg-brand_jaguar border-b-2 outline-0 	focus:border-brand_yellow	"
              type="password"
              value={password1}
              placeholder="Confirm Password"
              onChange={(e) => {
                setPassword1(e.target.value);
              }}
            />
            {/* <label for="profile_pic">Choose Profile Pic</label>
              

          <input className="my-2 cursor-pointer " 
          type="file"   
          name="profile_pic"
          accept=".jpg, .jpeg, .png"
          /> */}

            <label htmlFor="profile">Profile Picture</label>
            <input
            onChange={(e) => { changeImageHandler(e)}}
            accept="image/*"
              className="w-full my-2  cursor-pointer"
              id="profile"
              type="file"
            />

            <button disabled={loading} className={`transition hover:-translate-y-1 ${loading ? 'bg-yellow-100 text-gray-600' : 'bg-brand_yellow text-black'} my-4 ease-linear   px-6 py-1  font-outfit font-semibold`}>
              Sign Up
            </button>
          </form>
          <h1 className="my-1">
            Already have and account?{" "}
            <Link to="/login">
              <span className="hover:underline text-brand_yellow">Sign in</span>
            </Link>
          </h1>
        </div>
      </div>
    </>
  );
};

export default Signup;
